// app/javascript/widget/reveal.ts
//
// Задержка показа ответа по остатку с сервера (message.reveal_in_ms).
// Сервер считает человеческий темп ответа (Assistants::Pacing), но не спит в
// воркере: ответ приходит в ленту сразу, а показывается по сроку. Остаток
// сервер считает в момент ответа на опрос, поэтому часы гостя в расчёте не
// участвуют. Чистая функция — тестируется без DOM (reveal.test.mjs).

/** Потолок удержания: страховка от кривого значения — дольше не держим. */
export const MAX_HOLD_MS = 15_000;

/** Сколько миллисекунд держать ответ до показа: 0 — показывать сразу. */
export function holdMs(revealInMs: number | undefined): number {
  if (typeof revealInMs !== 'number' || !Number.isFinite(revealInMs) || revealInMs <= 0) return 0;
  return Math.min(MAX_HOLD_MS, Math.round(revealInMs));
}
